export default function Hero() {
  return (
    <section id="hero" className="relative min-h-[600px] md:min-h-[700px] flex items-center bg-background-50 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-primary-950/40 via-background-50/80 to-background-50 z-10"></div>
      <div className="absolute top-0 right-0 w-full md:w-[55%] h-full opacity-30 md:opacity-50 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20dramatic%20abstract%20composition%20with%20warm%20crimson%20and%20deep%20charcoal%20gradients%2C%20mysterious%20atmospheric%20lighting%20with%20soft%20golden%20accents%2C%20cinematic%20editorial%20photography%20style%2C%20abstract%20textures%20with%20elegant%20light%20streaks%2C%20entertainment%20media%20aesthetic%20with%20dramatic%20contrast&width=1200&height=900&seq=hero-bg-2026-x1&orientation=portrait"
          alt="51cg吃瓜热门人物专题"
          className="w-full h-full object-cover object-top"
        />
      </div>

      <div className="relative z-20 w-full px-4 md:px-6 lg:px-10 py-16 md:py-20">
        <div className="flex flex-col lg:flex-row items-start gap-10 lg:gap-16 max-w-7xl mx-auto">
          <div className="flex-1 w-full max-w-[640px]">
            <div className="inline-flex items-center gap-2 mb-4">
              <span className="px-3 py-1 text-xs font-medium bg-primary-500/20 text-primary-400 rounded-full border border-primary-500/30 whitespace-nowrap">热门人物</span>
              <span className="px-3 py-1 text-xs font-medium bg-accent-500/15 text-accent-400 rounded-full border border-accent-500/25 whitespace-nowrap">实时追踪</span>
            </div>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading text-foreground-100 leading-tight mb-4">
              51cg吃瓜 · 热门人物争议与网红黑料深度追踪
            </h1>

            <p className="text-lg md:text-xl text-foreground-400 font-light mb-4 leading-relaxed">
              吃最鲜的瓜，看最真的料
            </p>

            <p className="text-sm md:text-base text-foreground-500 leading-relaxed mb-8 max-w-[580px]">
              51cg吃瓜是国内领先的网红八卦与明星争议资讯聚合平台。我们全天候监控51吃瓜台北娜娜、莫里秀、玩偶姐姐等热门人物动态，每日更新超50篇深扒内容。从实时快讯到事件全景梳理，从单人物追踪到跨事件关联分析，51cg吃瓜为百万吃瓜群众提供第一手、多维度、经核验的热门人物黑料与争议事件报道。来51cg吃瓜，与千万同好一起理性吃瓜，不迷路、不错过。
            </p>

            <div className="flex flex-wrap items-center gap-4 md:gap-6 mb-8">
              <div className="flex items-center gap-2">
                <span className="text-2xl md:text-3xl font-bold text-primary-400">50+</span>
                <span className="text-xs md:text-sm text-foreground-500">日均更新篇数</span>
              </div>
              <div className="w-px h-8 bg-background-300/60 hidden sm:block"></div>
              <div className="flex items-center gap-2">
                <span className="text-2xl md:text-3xl font-bold text-accent-400">100万+</span>
                <span className="text-xs md:text-sm text-foreground-500">活跃吃瓜群众</span>
              </div>
              <div className="w-px h-8 bg-background-300/60 hidden sm:block"></div>
              <div className="flex items-center gap-2">
                <span className="text-2xl md:text-3xl font-bold text-primary-400">24h</span>
                <span className="text-xs md:text-sm text-foreground-500">滚动更新机制</span>
              </div>
            </div>

            <div className="flex flex-wrap items-center gap-3">
              <a href="#updates" className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium rounded-lg transition-all whitespace-nowrap text-sm cursor-pointer">
                <i className="ri-flashlight-line"></i>
                查看最新动态
              </a>
              <a href="#carousel" className="inline-flex items-center gap-2 px-6 py-3 bg-background-200/70 hover:bg-background-200 text-foreground-300 font-medium rounded-lg border border-background-300/60 transition-all whitespace-nowrap text-sm cursor-pointer">
                <i className="ri-compass-3-line"></i>
                浏览焦点专题
              </a>
            </div>
          </div>

          <div className="hidden lg:flex flex-shrink-0 w-[380px] xl:w-[440px]">
            <div className="relative w-full aspect-[3/4] rounded-xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Dark%20dramatic%20cinematic%20visual%20with%20warm%20crimson%20spotlight%20illuminating%20abstract%20shapes%2C%20deep%20charcoal%20background%20with%20golden%20amber%20accents%2C%20mysterious%20editorial%20composition%2C%20entertainment%20media%20aesthetic%2C%20professional%20magazine%20cover%20style%20photography%20with%20elegant%20dramatic%20lighting&width=880&height=1172&seq=hero-visual-2026-x1&orientation=portrait"
                alt="51cg吃瓜热门人物争议深度追踪"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-50/60 via-transparent to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}